import './categoryChip.css'

/**
 * A category's name, in the app's own chip treatment — a list row, a filter,
 * a detail header.
 *
 * **No colour.** #454 removed category colour from the web app entirely: the
 * server still stores and returns `color` (and iOS still sets one), but every
 * category renders identically here regardless of what the API sends. This
 * component used to draw a coloured dot beside the name from that field, and
 * a separate dot-only component served callers that render the name
 * themselves; both dots are gone rather than repainted grey, since a dot whose
 * only job was to carry a colour has nothing left to show once every category
 * looks the same.
 */
export function CategoryChip({ name, size = 'row' }: { name: string; size?: 'row' | 'chip' }) {
  return (
    <span className={`category-chip category-chip--${size}`}>
      <span className="category-chip__name">{name}</span>
    </span>
  )
}
